import { render, staticRenderFns } from "./DateLabel.vue?vue&type=template&id=8bdbd67a&scoped=true&"
import script from "./DateLabel.vue?vue&type=script&lang=js&"
export * from "./DateLabel.vue?vue&type=script&lang=js&"
import style0 from "./DateLabel.vue?vue&type=style&index=0&id=8bdbd67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdbd67a",
  null
  
)

export default component.exports